import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BankAccountReducer } from '../reducers';

export const selectBankAccountFeature = createFeatureSelector<BankAccountReducer.BankAccountState>(BankAccountReducer.featureName);

export const selectBankAccount = createSelector(selectBankAccountFeature, (state: BankAccountReducer.BankAccountState) => state.item);
